'use client';
import { CollapsibleSection } from '@/app/components/shared/viewer/CollapsibleSection';
import { PublishedModelBody } from '@/app/published/components/molecules/PublishedModel';
import { RapidModel } from '@/types/rapidModel';
import { RawModel } from '@/types/rawModel';
import { Skeleton, Stack, StackProps, Switch, Text } from '@mantine/core';
import { useAssetEmbeds } from '../organisms/hooks';
import { useState } from 'react';

interface EmbedsProps extends StackProps {
  asset: RapidModel | RawModel;
  maw: number;
}

export function Embeds({ asset, ...props }: EmbedsProps) {
  const [showOneClick, setShowOneClick] = useState(false);
  const { data: embeds, isLoading, isError } = useAssetEmbeds(asset.id, showOneClick);

  if (asset.assetType === 'raw') {
    return null;
  }

  return (
    <CollapsibleSection title='Embed'>
      <Stack {...props}>
        {isLoading && <Skeleton height={100} />}
        {isError && <Text>Failed to load embeds.</Text>}
        {!isError && !isLoading ? (
          <Switch
            label='Show one-click shares'
            checked={showOneClick}
            onChange={(event) => setShowOneClick(event.currentTarget.checked)}
          />
        ) : null}
        {embeds?.length === 0 && <Text>No embeds created for this asset.</Text>}
        <Stack gap={2}>
          {embeds?.map((embed) => <PublishedModelBody key={embed.id} autoActionsGap model={embed} withDelete />)}
        </Stack>
      </Stack>
    </CollapsibleSection>
  );
}
